import { Component, Input } from "@angular/core";
import { ShortcutInfo } from "../../../services";

@Component({
    selector: "shortcut-group",
    templateUrl: './shortcutGroup.tmpl.html',
    styleUrls: [
        "./shortcutGroup.component.scss"
    ],
    standalone: false
})
export class ShortcutGroupComponent
{
    @Input() readonly group: string;
    @Input("shortcuts") set boundShortcuts(value: ReadonlyArray<ShortcutInfo>)
    {
        this.shortcuts = [...value];
        this.shortcuts?.sort((a, b) =>
        {
            return a.Keys > b.Keys
                ? 1
                : b.Keys > a.Keys
                    ? -1
                    : 0;
        });
    }

    shortcuts: Array<ShortcutInfo>;
}
